import { render, staticRenderFns } from "./AllergenPropagationTree.vue?vue&type=template&id=d11911f0&scoped=true"
import script from "./AllergenPropagationTree.vue?vue&type=script&lang=ts"
export * from "./AllergenPropagationTree.vue?vue&type=script&lang=ts"
import style0 from "./AllergenPropagationTree.vue?vue&type=style&index=0&id=d11911f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11911f0",
  null
  
)

export default component.exports